module.exports = {
      id: "search-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "svg-sprite-71cc17c6d762c8495e8a5375f2902e76.svg#search",
      toString: function () {
        return this.url;
      }
    }